import { PurchaseFormValues } from '../../../types/purchases/BasePurchase';
import { PurchaseFinalizeDTO } from './types';

export const mapTaxCreditPurchase = (form: PurchaseFormValues): PurchaseFinalizeDTO => {
  const condition = form.paymentCondition;

  const mappedCondition = condition
    ? {
        id: condition.id,
        name: condition.name,
        code: condition.code,
        creditDays: condition.creditDays || undefined,
        creditDueDate: condition.creditDueDate || undefined,
        creditMonths: condition.creditMonths || undefined,
        creditYears: condition.creditYears || undefined,
        termId: condition.termId || undefined, 
        termName: condition.termName || undefined,
        termCode: condition.termCode || undefined,
      }
    : null;

  return {
    comments: form.comments?.trim() || '',
    paymentCondition: mappedCondition,
    paymentMethod: form.paymentMethod
      ? {
          id: form.paymentMethod.id,
          name: form.paymentMethod.name,
          code: form.paymentMethod.code,
        }
      : null,
    individualPayments: form.individualPayments || null,
  };
};
